<template>
    <div>
        <content-view v-show="$utils.renderWhen(this, 'companyGroup')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="礼券名称">
                        <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="商品分类">
                        <a-select allowClear placeholder="请选择" v-decorator="['goodCategory']" @select="search">
                            <a-select-option v-for="(item, index) in goodsList" :key="index" :value="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="展示名称">
                        <a-input placeholder="请输入" v-decorator="['goodName']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="内部标识">
                        <a-input placeholder="请输入" v-decorator="['goodInnerName']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="兑换有效期">
                        <a-range-picker
                            style="width:282px"
                            format="YYYY/MM/DD"
                            v-decorator="['selectDate']"
                            @change="search"
                        />
                    </a-form-item>
                    <a-form-item label="团购门店">
                        <a-select allowClear placeholder="请选择" v-decorator="['groupShopId']" @select="search">
                            <a-select-option v-for="(item, index) in shopList" :key="index" :value="item.value">{{item.label}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div style="background: #eee">
                <a-spin :spinning="spinning">
                    <a-card
                    :bordered="false"
                    :tabList="tabListNoTitle"
                    :activeTabKey="noTitleKey"
                    @tabChange="key => onTabChange(key,'noTitleKey')"
                    >
                        <template v-if="giftLists.length">
                            <a-checkbox @change="onChange" :defaultChecked="true" class="mb24">
                                只显示可售
                            </a-checkbox>
                            <div class="companyOrder-box" :pagination="pagination">
                                <section class="companyOrder-gifts" v-for="(item, index) in giftLists" :key="index">
                                    <div class="companyOrder-gifts-title">{{item.name}}</div>
                                    <div class="companyOrder-gifts-detial">
                                        <span>商品分类: </span><span>{{TYPE[item.goodCategory]}}</span><br>
                                        <span>展示名称: </span><span>{{item.goodName}}</span><br>
                                        <span>内部标识: </span><span>{{item.goodInnerName}}</span><br>
                                        <br>
                                        <span>可售库存: </span><span>{{item.availableNum}}/{{item.num}}</span><br>
                                        <span>兑换有效期: </span><span v-if="item.isHasExpiryDate == 0">不限期</span><span v-else-if="item.isHasExpiryDate == 1">{{item.startExpiryDate}}~{{item.endExpiryDate}}</span><span v-else>-</span><br>
                                        <span>团购销售门店: </span><span v-if="item.groupBuyShopType == 0">全部门店</span><span v-else-if="item.groupBuyShopType == 1">{{item.couponGroupBuyShopList | getShopName}}</span><span v-else>-</span><br>
                                        <span>状态: </span><span>{{item.status == '-1' ? '停用' : '正常'}}</span><br>
                                    </div>
                                    <div class="companyOrder-gifts-btn" v-if="getBtnByAuth('companyGroupAdd') && getBtnByAuth('companyGroupDetail')">
                                        <p v-if="getBtnByAuth('companyGroupAdd')" @click="toCreateOrder(item.id)">创建订单</p>
                                        <p v-if="getBtnByAuth('companyGroupAdd') && getBtnByAuth('companyGroupDetail')"></p>
                                        <p v-if="getBtnByAuth('companyGroupDetail')" @click="toOrderDetail(item.id)">查看详情</p>
                                    </div>
                                </section>
                            </div>
                            <a-pagination
                                show-size-changer
                                v-model="pagination.current"
                                :total="pagination.total"
                                :page-size="pagination.pageSize"
                                @showSizeChange="changePage"
                                :showTotal="pagination.showTotal"
                                @change="changePage"
                                class="flex flex-end"
                                :defaultPageSize="pagination.defaultPageSize"
                                :pageSizeOptions="pagination.pageSizeOptions"
                            />
                        </template>
                        <div v-if="giftLists.length === 0">
                            <a-empty />
                        </div>
                    </a-card>
                </a-spin>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
const TYPE = ["", "线上票", "线下票", "优惠券", "储值"]
import { mapGetters } from "vuex";
export default {
    name: "companyOrder",
    components: {
    },
    props: {},
    data() {
        const tabListNoTitle = [
            {
                key: '1',
                tab: '兑换商品'
            },
            // {
            //     key: '2',
            //     tab: '标准商品'
            // },
        ]
        return {
            TYPE,
            noTitleKey: '1',
            tabListNoTitle: tabListNoTitle,
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: false,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 9,
                defaultPageSize: 9,
                pageSizeOptions: ["9", "18", "27", "36"]
            },
            spinning: false,
            goodsList: [
                {
                    name: "线上票",
                    id: 1,
                },
                {
                    name: "线下票",
                    id: 2,
                },
                {
                    name: "优惠券",
                    id: 3,
                },
                {
                    name: "储值",
                    id: 4,
                },
            ],
            shopList: [],
            tabKey: "1",
            giftLists: [],
            isSold: 1,
        };
    },
    watch: {
        'shopId'(val) {
            this.getList();
        },
        $route(val) {
            if (val.name == "companyGroup") {
                this.getList()
            }
        }
    },
    computed: {
        ...mapGetters(["shopId"])
    },
    filters: {
        getShopName(val) {
            var shopName = '';
            if (val.length) {
                val.forEach(el => {
                    shopName += el.shopName + ','
                });
                return shopName.substring(0, shopName.length - 2);
            } else {
                return "-";
            }
        }
    },
    methods: {
        toCreateOrder(id) {
            this.$router.push({name: "companyOrderCreate", query: {id}})
        },
        toOrderDetail(id) {
            this.$router.push({name: "companyOrderDetail", query: {id}})
        },
        onChange(e) {
            this.isSold = Number(e.target.checked);
            this.getList();
        },
        outTabsChange(key) {
            this.tabKey = key;
            this.getList();
        },
        handleReset() {
            this.form.resetFields();
            this.getList()
        },
        search() {
            this.pagination.current = 1;
            this.getList();
        },
        changePage(page, pageSize) {
            this.pagination.current = page;
            this.pagination.pageSize = pageSize;
            this.getList();
        },
        onTabChange(noTitleKey) {
            this.noTitleKey = noTitleKey
            this.pagination.current = 1;
            this.getList()
        },
        getList() {
            this.form.validateFields((err, values) => {
                if (err) return;
                const rangeValue = values['selectDate'] ? values['selectDate'] : []
                values.startExpiryDate = rangeValue.length > 0 ? rangeValue[0].format('YYYY-MM-DD') : undefined
                values.endExpiryDate = rangeValue.length > 0 ? rangeValue[1].format('YYYY-MM-DD') : undefined
                values.groupShopIdList = [];
                if (values.groupShopId) {
                    values.groupShopIdList.push(values.groupShopId)
                }
                delete values.groupShopId;
                this.$api.changeCode.getGroupGoods({
                    body: Object.assign(values, {
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize,
                        isSell: this.isSold,
                        shopId: this.shopId,
                    })
                }).then((res) => {
                    this.pagination.total = res.total;
                    this.giftLists = res.list;
                })
            });
        },
        /**
         * @getShopList 获取门店列表
         */
        getShopList() {
            this.$api.totalPlatform.selectList().then(res => {
                res.forEach((item,index) => {
                    item.label = item.name;
                    item.value = item.id;
                });
                this.shopList = res;
            });
        },
    },
    created() {
        this.form = this.$form.createForm(this);
        this.getList();
        this.getShopList();
    },
    mounted() {}
}
</script>
<style lang="scss">
.companyOrder {
    &-header-button {
        width: 378px;
    }
    &-box {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    &-gifts {
        width: 360px;
        margin-bottom: 20px;
        margin-right: 20px;
        &-title {
            width: 360px;
            height: 64px;
            margin-bottom: 0;
            background: linear-gradient(90deg, rgba(246, 112, 126, 1) 0%, rgba(245, 133, 99, 1) 100%);
            padding: 0 20px;
            font-weight: 500;
            box-sizing: border-box;
            color: #FFF;
            line-height: 64px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
        &-detial {
            padding: 20px;
            box-sizing: border-box;
            border-left: 1px solid #EEE;
            border-right: 1px solid #EEE;
            border-bottom: 1px solid #EEE;
            span {
                font-size: rem(14px);
                color: rgba(0,0,0,0.85);
                &:nth-of-type(2n) {
                    color: rgba(0,0,0,0.45);
                }
            }
        }
        &-btn {
            width: 100%;
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(247, 249, 250, 1);
            p {
                width: 179px;
                height: 100%;
                font-size: 14px;
                color: rgba(0,0,0,0.45);
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 0;
                cursor: pointer;
                &:empty {
                    width: 1px;
                    height: 20px;
                    background: #EEE;
                }
            }
        }
    }
}
</style>